import HistorySlider from '../components/history-slider'
import Slider from '../components/slider'
import MapLocator from './../components/map-locator'
import CustomCheckbox from './../components/custom-checkbox'
import CustomRange from './../components/custom-range'
import Swatch from './../components/swatch'
import PostTypeFilter from './../components/post-type-filter'
import MegaMenu from '../components/mega-menu'
import Header from '../components/header'
import VideoPopup from '../components/video-popup'
import MiniCart from '../components/mini-cart';
// import Api from '../util/Api'

// List of all plug-and-play jquery plugin classes
const jqueryPlugins = [
  CustomCheckbox,
  CustomRange,
  PostTypeFilter,
  Swatch,
];

/**
 * Initiate select 2
 */
const initSelect = () => {
  $('select.custom-select').each(function () {
    let theme = 'default'
    if ($(this).data('select-theme')) {
      theme = $(this).data('select-theme')
    }
    $(this).select2({
      width: '100%',
      theme: theme,
      minimumResultsForSearch: -1,
    })
    if ($(this).data('select-navigation')) {
      $(this).on('change.select2', () => {
        let selected = $(this).select2('data')
        if (selected.length <= 0) {
          return
        }
        selected = selected[0]
        const url = selected.id
        window.location.href = url
      })
    } else if ($(this).attr('name') === 'location') {
      // Contact form location submission,
      // for zoho integration
      $(this).on('change.select2', () => {
        if (!$('#location_name').length) {
          return
        }
        $('#location_name').val($(this).val())
      })
    }
  })
}
window._init_select = initSelect

export default {
  // JavaScript to be fired on all pages
  init() {
    if ($('[data-control="history-slider"]').length) {
      let historySlider = new HistorySlider($('[data-control="history-slider"]'), $('[data-control="history-thumb-slider"]'))
      historySlider.init()
    }
    if ($('[data-control="gallery-slider"]').length) {
      let gallerySlider = new Slider($('[data-control="gallery-slider"]'), 'gallery')
      gallerySlider.init()
    }
    if ($('[data-control="map-locator"]').length) {
      MapLocator.init($('[data-control="map-locator"]'))
    }
    // JavaScript to be fired on all pages
    jqueryPlugins.forEach(plugin => {
      plugin.jqueryPlugin();
    });
    const megaMenu = new MegaMenu
    megaMenu.init()
    Header.init()

    // Auto bind video players
    let player = new VideoPopup('.js-video-popup')
    player.init()

    // Initialise mini cart
    let miniCart = new MiniCart($('[data-mini-cart]'))
    miniCart.init()

    // let payload = {'type':'posts','data':{'id':1,'status':'published','title':'My new comfortel post22','content':'<h2>Hello there!</h2>\n<p>asldkajsld</p>\n<p>asdlkasjdlasd</p>\n<p>New things</p>','featured_thumbnail':{'id':9,'storage':'local','filename_disk':'home-banner-1-urban-jungle-salon-funriture.jpg','title':'Home Banner 1 Urban Jungle Salon Funriture','type':'image/jpeg','uploaded_by':1,'uploaded_on':'2020-01-10T00:45:25+00:00','charset':'binary','filesize':226025,'width':1920,'height':900,'duration':0,'embed':null,'folder':null,'description':'','location':'','tags':[],'checksum':'45df243eb1ece0dbdf2882e4fb483d13','metadata':null,'private_hash':'7y26y08puwgsk40o','filename_download':'home-banner-1-urban-jungle-salon-funriture.jpg','data':{'full_url':'https://directus.test/uploads/comfortel/originals/home-banner-1-urban-jungle-salon-funriture.jpg','url':'/uploads/comfortel/originals/home-banner-1-urban-jungle-salon-funriture.jpg','thumbnails':[{'url':'https://directus.test/api/assets/7y26y08puwgsk40o?key=directus-small-crop','relative_url':'/api/assets/7y26y08puwgsk40o?key=directus-small-crop','dimension':'64x64','width':64,'height':64},{'url':'https://directus.test/api/assets/7y26y08puwgsk40o?key=directus-small-contain','relative_url':'/api/assets/7y26y08puwgsk40o?key=directus-small-contain','dimension':'64x64','width':64,'height':64},{'url':'https://directus.test/api/assets/7y26y08puwgsk40o?key=directus-medium-crop','relative_url':'/api/assets/7y26y08puwgsk40o?key=directus-medium-crop','dimension':'300x300','width':300,'height':300},{'url':'https://directus.test/api/assets/7y26y08puwgsk40o?key=directus-medium-contain','relative_url':'/api/assets/7y26y08puwgsk40o?key=directus-medium-contain','dimension':'300x300','width':300,'height':300},{'url':'https://directus.test/api/assets/7y26y08puwgsk40o?key=directus-large-crop','relative_url':'/api/assets/7y26y08puwgsk40o?key=directus-large-crop','dimension':'800x600','width':800,'height':600},{'url':'https://directus.test/api/assets/7y26y08puwgsk40o?key=directus-large-contain','relative_url':'/api/assets/7y26y08puwgsk40o?key=directus-large-contain','dimension':'800x600','width':800,'height':600},{'url':'https://directus.test/api/assets/7y26y08puwgsk40o?key=thumbnail','relative_url':'/api/assets/7y26y08puwgsk40o?key=thumbnail','dimension':'200x200','width':200,'height':200}],'embed':null}},'regions':[{'id':8,'post_id':1,'region_id':1},{'id':10,'post_id':1,'region_id':3},{'id':14,'post_id':1,'region_id':2}]},'action':'update'};
    // $('#testPayload').on('click', () => {
    //   Api.post('comfortel/v1/headless/consume', payload)
    //     .then((result) => {
    //       console.log(result)
    //     })
    // })

    var disableSubmit = false;
    $('input.wpcf7-submit[type="submit"]').click(function () {
      $(':input[type="submit"]').css('opacity', 0.5)
      if (disableSubmit == true) {
        return false;
      }
      disableSubmit = true;
      return true;
    })

    var wpcf7Elm = document.querySelector('.wpcf7');
    if (wpcf7Elm) {
      wpcf7Elm.addEventListener('wpcf7submit', function () {
        $(':input[type="submit"]').css('opacity', 1)
        disableSubmit = false;
      }, false);
    }
  },
  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
    initSelect()
  },
}




// WEBPACK FOOTER //
// ./scripts/routes/common.js